export default __webpack_public_path__ + "static/media/ch5-tennis-logo.68d7612f.png";